// js/utils.js
export const noteNames = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];

// Функция для получения названия ноты по струне и ладу
export function getNoteNameForPosition(string, fret, stringNotes) {
    const openStringNote = stringNotes[string - 1];
    const openNoteName = openStringNote.substring(0, openStringNote.length - 1);
    const openOctave = parseInt(openStringNote.slice(-1));

    const openNoteIndex = noteNames.indexOf(openNoteName);
    if (openNoteIndex === -1) return '';

    const noteIndex = (openNoteIndex + fret) % 12;
    const octave = openOctave + Math.floor((openNoteIndex + fret) / 12);

    return noteNames[noteIndex] + octave;
}

// Функция для расчета частоты ноты по названию (исправленная)
export function noteNameToFrequency(noteName) {
    // Разбираем название ноты (например "A4")

    const baseNote = noteName.substring(0, noteName.length - 1);
    const octave = parseInt(noteName.slice(-1));

    // Находим индекс ноты
    const noteIndex = noteNames.indexOf(baseNote);
    if (noteIndex === -1) return 0;

    // Рассчитываем номер полутона относительно A4
    // A4 - это 49-й MIDI-номер (440 Гц)
    const semitonesFromA4 = (octave - 4) * 12 + (noteIndex - 9);

    // Рассчитываем частоту по формуле f = 440 * 2^(n/12)
    return 440 * Math.pow(2, semitonesFromA4 / 12);
}